import Model from 'oc-jaco3d/arrangement/Model';
import { App } from '../App';
import Interior3d from "../arrangement3d/Interior3d";
import InteriorPopover from '../ui/organisms/popovers/InteriorPopover';
import { v3 } from 'oc-modules/oc-threejs/short3';
import { InteriorRestraint } from '../restraint/InteriorRestraint';
import Maths3 from 'oc-threejs/Maths3';
export default class Interior extends Model {

    constructor(parent, metadata, booth) {
        super(parent);
        this.key = metadata?.Model.Key;
        this.article = metadata?.DefaultArticle;
        this.booth = booth || APP.arrangement.booth;
        this.positionValid = true;
    }

    createJaco3d() {
        return new Interior3d(this);
    }

    rotateOnAxis(axis, angle) {
        super.rotateOnAxis(axis, angle);
        // this.booth.checkInteriorCollisions(this);
    }

    resetColor() {
        this.jaco3d.restoreColor();
    }

    onTap(event) {
        const offsetX = event.pageX > window.innerWidth - 200 ? -150 : 50;
        const offsetY = event.pageY > window.innerHeight - 200 ? -150 : 0;
        APP.arrangement.setPopover({
            positionX: event.pageX + offsetX,
            positionY: event.pageY + offsetY,
            content: InteriorPopover(this)
        })
        APP.arrangement.currentInterior = this;
    }

    compileInteriorRestraints() {
        return;
        const restraint = new InteriorRestraint({
            priority: 4,
            collisionHeightIntervalls: _.range(0.3,1,0.1),
            polygonSimplifyTollerance: 0.01,
            freeOrientationAroundMainAxis: true,
            offset: 0,
            showDebugVisualization: false,
        });
        this.restraint = restraint;

        APP.arrangement.interiorRestraints.push(restraint);
    }

    toJSON() {
        const json = super.toJSON();
        json.key = this.key;
        json.articleNumber = this.article.Artikelnummer;
        json.label = this.label;
        json.customTextures = this.customTextures || {};
        Scenes.filter(this.jaco3d, c => {return c.material?.customTextureName != null} ).forEach( mesh => {
            json.customTextures[mesh.name] = mesh.material.customTextureName; 
        });
        return json;
    }

    fromJSON(json) {
        super.fromJSON(json);
        this.key = json.key;
        this.article = APP.richMetadata.metadata.Artikel.find(a => a.Artikelnummer == (json.articleNumber || json.article.Artikelnummer));
        this.label = json.label;
        this.customTextures = json.customTextures;
        return this;
    }
}
